var PubSubObserver = /** @class */ (function () {
    function PubSubObserver() {
        this.subscriptions = [];
    }
    PubSubObserver.prototype.publish = function (signal) {
        this.subscriptions.forEach(function (subscription) {
            // TODO: implement complex query logic https://jira.expedia.biz/browse/CKOE-2685
            if (subscription.query.type === signal.type) {
                subscription.callback(signal);
            }
        });
    };
    PubSubObserver.prototype.subscribe = function (subscription) {
        if (!this.subscriptions.includes(subscription)) {
            this.subscriptions.push(subscription);
        }
    };
    PubSubObserver.prototype.unsubscribe = function (subscription) {
        this.subscriptions = this.subscriptions.filter(function (elem) { return subscription !== elem; });
    };
    return PubSubObserver;
}());
export var PubSubEventManager = new PubSubObserver();
//# sourceMappingURL=index.js.map